import { render, staticRenderFns } from "./UsersVrioTable.vue?vue&type=template&id=2d7d4c86&"
import script from "./UsersVrioTable.vue?vue&type=script&lang=js&"
export * from "./UsersVrioTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports